<template>
  <div>
    <a href="#top">
      <v-btn text block x-large class="py-16">
        <h2 class="text-center" style="color: white !important;">
            ☝️ Scroll to top
        </h2>
      </v-btn>
    </a>
  </div>
</template>
<script lang="ts">
import { defineComponent } from 'vue'

export default defineComponent({
  name: "ScrollToTopComponent",
  components: {
  },
});
</script>